export default {"src":"/_next/static/media/featuredbadge.25778ae0.svg","height":24,"width":115,"blurWidth":0,"blurHeight":0};